






















import Vue from 'vue'
import axios, { AxiosResponse } from 'axios'

const filePath = process.env.NODE_ENV === 'production'
               ? '/js-apps/data/distributors.tsv'
               : './distributors.tsv'


export default Vue.extend({
  name: 'App',
  data() {
    return {
      countries: [] as string[],
      selectedCountry: '' as string,
      distributors: [] as string[][],
    }
  },
  async created() {
    const data: string = await axios.get(filePath).then((res: AxiosResponse) => res.data)
    const result = parseTsv(data)

    this.distributors = result.map(a => {
      const temp = a.slice(0, 3)
      return temp.concat(a.slice(3).map(convertLink))
    })

    const targets = result.map(a => a[0]).reduce((acc: string[], s) => acc.concat(s.split(',')), [])
    this.countries = targets.filter((x, i, self) => self.indexOf(x) === i)
  },
  computed: {
    filterdDists(): string[][] {
      return this.distributors.filter(d => d[0].split(',').find(t => this.selectedCountry === t) !== undefined)
    },
  },
});

const parseTsv = (str: string) => {
  return str.split('\n')
          .map(s => s.trim())
          .filter(s => s.length !== 0)
          .map(s => s.split('\t'))
}

const convertLink = (text: string) => {
  text = text.replace(/</gi, '&lt;')
  text = text.replace(/>/gi, '&gt;')
  for (let i = 0; 0 <= text.indexOf('[', i);) {
    const titleStart = text.indexOf('[', i)
    const titleEnd = text.indexOf(']', i)
    const urlStart = text.indexOf('(', i)
    const urlEnd = text.indexOf(')', i)

    if (titleEnd + 1 === urlStart) {
      const beforeLinkString = text.substring(0, titleStart)
      const afterLinkString = text.substring(urlEnd + 1, text.length)

      const linkStringLength = text.substring(titleStart, urlEnd + 1).length

      const linkTitle = text.substring(titleStart + 1, titleEnd)

      const linkUrl = text.substring(urlStart + 1, urlEnd)

      const tag = `<a href="${linkUrl}" target="_blank">${linkTitle}</a>`
      text = beforeLinkString + tag + afterLinkString

      i = urlEnd + 1
      i += (tag.length - linkStringLength)
    } else {
      i = urlEnd + 1
    }
    return text
  }
  return text
}

